import { render } from "./SaldoCard.vue?vue&type=template&id=148b66b2&scoped=true"
import script from "./SaldoCard.vue?vue&type=script&lang=js"
export * from "./SaldoCard.vue?vue&type=script&lang=js"

import "./SaldoCard.vue?vue&type=style&index=0&id=148b66b2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148b66b2"]])

export default __exports__